import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Redirect, Route} from "react-router-dom";
import { useSnackbar } from "notistack";
import DefaultLayout from "../pages/_layouts/default";
import Error from "../pages/Error";
import { useAuth } from "../hooks/auth/AuthContext";

import api from "../services/api";
import { store } from "../store";

export default function RouteWrapper({
  component: Component,
  isSudo,
  ...rest
}) {
  const { signed, token } = store.getState().auth;
  const { logout, adminUser} = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (signed && token && typeof token === 'string') {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Math.round(new Date().getTime() / 1000);
      const expirationTime = payload.exp;
      const leeway = 600;

      if (currentTime - leeway - expirationTime > 1) {
        enqueueSnackbar("Tempo de sessão expirou!", { variant: "warning" });
        logout();
      }
    }
  }, [signed, token]);

  if(!signed){
    return <Redirect to="/" />;
  }
  // Aguardar verificação de admin (null = carregando)
  if (adminUser === null) {
    return null;
  }
  //permissao de aluno e empresa
  if (!adminUser) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <DefaultLayout>
          <Component {...props} />
        </DefaultLayout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isSudo: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isSudo: false,
};